import React from 'react';
import { Link } from 'react-router-dom';
import { tools } from '../data/tools';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const SitemapPage = () => {
  const sections = [
    {
      title: 'Main Pages',
      links: [
        { name: 'Home', path: '/' },
        { name: 'All Tools', path: '/tools' },
        { name: 'Hire Me', path: '/hire' },
        { name: 'Blog', path: '/blog' },
        { name: 'Contact', path: '/contact' },
        { name: 'About', path: '/about' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', path: '/privacy' },
        { name: 'Terms of Service', path: '/terms' }
      ]
    }
  ];

  const categories = [...new Set(tools.map(tool => tool.category))];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Sitemap</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-8">Complete overview of all pages on DevTools Hub</p>

          <div className="space-y-6">
            {sections.map((section, index) => (
              <Card key={index} className="border-gray-200 dark:border-gray-800">
                <CardHeader>
                  <CardTitle>{section.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {section.links.map((link, i) => (
                      <li key={i}>
                        <Link
                          to={link.path}
                          className="text-blue-600 dark:text-blue-400 hover:underline"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}

            {/* Tools by Category */}
            {categories.map(category => {
              const categoryTools = tools.filter(tool => tool.category === category);
              return (
                <Card key={category} className="border-gray-200 dark:border-gray-800">
                  <CardHeader>
                    <CardTitle>{category} Tools</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      {categoryTools.map(tool => (
                        <li key={tool.id}>
                          <Link
                            to={tool.path}
                            className="text-blue-600 dark:text-blue-400 hover:underline"
                          >
                            {tool.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;